import { TCharterSource } from './type';

export const partnerTabs: Array<{ name: string; key: TCharterSource | string | null | undefined }> = [
  { name: 'All', key: TCharterSource.All },
  { name: 'Own', key: TCharterSource.Own },
  { name: 'Promo code', key: TCharterSource.PromoCode },
  { name: 'Referral link', key: TCharterSource.ReferralLink },
  { name: 'Partner', key: TCharterSource.Partner },
];
